import React from "react";
import { BookIcon, CheckIcon, GiftIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CountdownTimer } from "../CountdownTimer";
import { ScarcityBar } from "../ScarcityBar";
import { bonuses, images } from "../../data/landingContent";
const includes = ["All 6 premium volumes", "All 5 exclusive bonuses", "Instant digital access", "Downloadable reference materials", "Lifetime access to your purchased files", "7-day money-back guarantee"];
export function OfferSection() {
  return <section id="offer" className="bg-white px-4 py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-204" data-mp="1oesyzjexeds">
      <div className="mx-auto max-w-xl" data-id="element-205" data-mp="3suomrgm6m7ij">
        <p className="text-center text-xs font-bold uppercase tracking-[0.14em] text-rose sm:text-sm" data-id="element-206" data-mp="3ny7z0niw9v5z">
          Your complete Menopause Decision Map™ offer
        </p>
        <h2 id="offer-title" className="mt-3 text-balance text-center font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-207" data-mp="3j0fxd1sg6uol">
          Here's everything you'll receive when you join today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border-4 border-plum bg-white shadow-[0_24px_50px_-24px_rgba(78,26,55,0.5)]" data-id="element-208" data-mp="1fih0fmwgp4mb">
          <img src={images.hero} alt="Complete Menopause Decision Map™ collection" className="w-full bg-cream" data-id="element-209" data-mp="10uw1842pjpjo" />

          <div className="space-y-4 p-5 sm:p-7" data-id="element-210" data-mp="15tgybumnxt3w">
            <div className="flex items-start justify-between gap-3 border-b border-plum/10 pb-4" data-id="element-211" data-mp="1tirtmwl8uvan">
              <div className="flex gap-3" data-id="element-212" data-mp="1yhcrwqgxr4wg">
                <BookIcon className="mt-0.5 h-5 w-5 shrink-0 text-plum" aria-hidden="true" data-id="element-213" data-mp="1yga10ijm52gj" />
                <div data-id="element-214" data-mp="1kh209l7sxma8">
                  <p className="font-bold text-ink" data-id="element-215" data-mp="1khk8lg7qnqyi">Menopause Decision Map™ — Six Premium Volumes</p>
                  <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-216" data-mp="1ohm1azvhxa1n">
                    Assessment, symptoms, risk considerations, treatment discussions, follow-up, and consultation tools.
                  </p>
                </div>
              </div>
              <s className="shrink-0 font-semibold text-red-600" data-id="element-217" data-mp="2fr6zw754884f">$97</s>
            </div>

            <div className="border-b border-plum/10 pb-4" data-id="element-218" data-mp="2arax2b85mmqg">
              <div className="flex items-start justify-between gap-3" data-id="element-219" data-mp="2atxagrhq7wgl">
                <p className="flex items-center gap-3 font-bold text-ink" data-id="element-220" data-mp="25zjcqifldd8r">
                  <GiftIcon className="h-5 w-5 shrink-0 text-rose" aria-hidden="true" data-id="element-221" data-mp="212sv3qo529l8" />
                  Five Exclusive Bonuses
                </p>
                <s className="shrink-0 font-semibold text-red-600" data-id="element-222" data-mp="1wycwmaguu4g1">$125</s>
              </div>
              <ul className="mt-2 space-y-1.5 pl-8" data-id="element-223" data-mp="1s3fmt1br3r23">
                {bonuses.map(b => <li key={b.number} className="text-sm leading-snug text-muted" data-id="element-224" data-mp="1n2i3glf08qz0">
                    {b.title}
                  </li>)}
              </ul>
            </div>

            <p className="text-center text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-225" data-mp="3hfram6k2w0e3">
              Total reference value: <s className="text-red-600" data-id="element-226" data-mp="3cfd9z9kt3sq3">$222</s>
            </p>

            <div className="rounded-2xl bg-blush px-4 py-5 text-center" data-id="element-227" data-mp="3kxf9gl3ivww4">
              <p className="text-sm font-bold uppercase tracking-wide text-plum" data-id="element-228" data-mp="3oz0i1u90xp0i">Today, get everything for just:</p>
              <p className="mt-1 font-serif text-7xl font-extrabold leading-none text-cta" data-id="element-229" data-mp="3trjxyxv6ow8h">
                $27<span className="ml-1 align-top font-sans text-lg font-bold text-ink" data-id="element-230" data-mp="2j60nzyfh63z">USD</span>
              </p>
              <p className="mt-2 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-231" data-mp="320x8re6p4mnq">One-time payment</p>
            </div>

            <ul className="space-y-2" data-id="element-232" data-mp="3630nqcskq9dr">
              {includes.map(item => <li key={item} className="flex items-center gap-2.5 text-[16px] text-ink" data-id="element-233" data-mp="3ayg0f1euhz8l">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-234" data-mp="3g0ou5zzjl5br">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-235" data-mp="q9a6mdz39hy5" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <p className="text-center text-sm text-muted" data-id="element-236" data-mp="246mlwjvkwb7l">
              No monthly subscriptions. No recurring fees. Just one payment for the complete digital collection.
            </p>

            <div className="flex items-start gap-2.5 rounded-xl border border-plum/15 bg-cream p-3.5 text-sm text-ink" data-id="element-237" data-mp="2d7krh6lo0qsa">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-plum" aria-hidden="true" data-id="element-238" data-mp="2863on5jmeu92" />
              <span data-id="element-239" data-mp="2n34k9k4xn9ct">
                <strong data-id="element-240" data-mp="2n2kyfsc5w0ti">Automatic currency conversion:</strong> your currency will be calculated automatically according
                to your country at checkout, where supported.
              </span>
            </div>

            <CtaButton label="Yes! I want Menopause Decision Map™ for $27" data-id="element-241" data-mp="2rve7gsenxvbe" />
            <p className="flex items-center justify-center gap-1.5 text-sm text-muted" data-id="element-242" data-mp="2rxig1nnibii0">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-243" data-mp="35vghxtkn5mgm" />
              Instant Access · Secure Checkout · 7-Day Guarantee
            </p>

            <CountdownTimer data-id="element-244" data-mp="3khcj9iu02igh" />
            <ScarcityBar data-id="element-245" data-mp="3kj730ttjc4iz" />
          </div>
        </div>
      </div>
    </section>;
}